import { Icons } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from 'store/reducers/reducer';
import { getAnalyticsEmbedUrl } from 'store/sagas/sagas';
export const Analytics = () => {
    const { asyncDispatch } = useGlobalState();
    const [embedUrl, setEmbedUrl] = useState('');
    const [loadingError, setLoadingError] = useState(false);
    useEffect(() => {
        asyncDispatch(getAnalyticsEmbedUrl())
            .then((resp) => {
            setEmbedUrl(resp.embedUrl);
            setLoadingError(false);
        })
            .catch((error) => {
            console.error(error);
            setLoadingError(true);
        });
    }, []);
    return (React.createElement("div", { style: { width: '100%', height: '100vh' } }, embedUrl ? (React.createElement("iframe", { allowFullScreen: true, height: "100%", src: embedUrl, width: "100%" })) : (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        } }, loadingError ? (React.createElement("p", null, "We encountered an error while loading your Analytics. Please try again.")) : (React.createElement("div", { style: {
            textAlign: 'center'
        } },
        React.createElement(Icons.Loading, null),
        React.createElement("p", null, "Loading Analytics")))))));
};
